import { camelCase, snakeCase, toUpper } from 'lodash';
// import ENUMS from '../constants/enums';
import intlData from '../../i18n/build/data.json';
import ENUMS_TRANSFORM from '../constants/transformToEnum';
import { upperTwoToName } from '../constants/countries';

/**
 * translating the eNums to intl key
 * @param {string} path intl path
 * @param {eNum} eNum
 * @param {string} language
 */
// export const eNumToIntel = (path, eNum, language = 'en') => {
//   if (eNum === 0 || eNum === null) return null;
//   console.log(
//     intlData[language][`${path.toLowerCase()}.${ENUMS_TRANSFORM[path.toUpperCase()][eNum]}`]
//   );
//   return intlData[language][`${path.toLowerCase()}
//        .${ENUMS_TRANSFORM[path.toUpperCase()][eNum]}`];
// };

export const eNumToIntel = (path, eNum, language = 'en') => {
  if (!eNum) return null;
  // console.log(
  //   intlData[language][`${camelCase(path)}.${ENUMS_TRANSFORM[toUpper(snakeCase(path))][eNum]}`]
  // );
  let currentEnum = ENUMS_TRANSFORM[toUpper(snakeCase(path))][eNum];
  if (
    currentEnum.includes('_') &&
    (currentEnum.includes('us') || currentEnum.includes('uk') || currentEnum.includes('cn') || currentEnum.includes('de') || currentEnum.includes('it') || currentEnum.includes('fr') || currentEnum.includes('es'))
  ) {
    currentEnum = currentEnum.substr(0, currentEnum.length - 3);
  }
  if (
    // currentEnum.toLowerCase().includes('uk') ||
    // commented out if QA finds any naming bugs in the site
    currentEnum.toLowerCase().includes('us') ||
    currentEnum.toLowerCase().includes('cn')
  ) {
    currentEnum = currentEnum.substr(0, currentEnum.length - 2);
  }
  return intlData[language][`${camelCase(path)}.${currentEnum}`];
  //  example intlData[en][listing.shippingMethods]
};

/**
 * eNums to icon types
 * @param {*} path
 * @param {*} eNum
 */
export const enumToType = (path, eNum) => {
  let type = ENUMS_TRANSFORM[path.toUpperCase()][eNum];
  if (type.includes('_')) {
    type = type.substr(0, type.length - 3);
  }
  type = ENUMS_TRANSFORM[path.toUpperCase()][eNum].toLowerCase();
  if (type.includes('uk') || type.includes('us') || type.includes('ca') || type.includes('cn') || type.includes('de') || type.includes('it') || type.includes('fr') || type.includes('es')) {
    type = type.substr(0, type.length - 2);
  }
  if (type === 'azd') {
    return 'amazon';
  }
  return type;
};

/**
 * extract country name from 2-letter notation
 * assuming the input is is either in iso2 notation or is a market name enum
 * @param {*} path
 * @param {*} eNum
 */
export const enumToCountryName = (path, eNum) => {
  const iso2 =
    path.length === 2 && !eNum
      ? path.toUpperCase()
      : ENUMS_TRANSFORM[path.toUpperCase()][eNum].toUpperCase();
  let country = upperTwoToName[iso2];
  if (!country) {
    country = upperTwoToName[iso2.slice(-2)];
  }
  return country || upperTwoToName.US;
};
